// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_s-0";
export var skeletonCard = "_s-1";